module.exports = __webpack_public_path__ + "img/Logo_footer.9a8384ae.svg";